import './App.css';
import Content from './components/Content';
import Footer from './components/Footer';
import Header from './components/Header';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import { MovieContext } from './Context';

function App() {

  const API_KEY = 'api_key=f779d476cdec5963c1d23b8c6fea72dc';
  const BASE_URL = useState('https://api.themoviedb.org/3/');

  const [movies, setMovies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [API_URL, setAPI_URL] = useState(BASE_URL[0]+'/trending/movie/day?'+API_KEY);
  const [movieURL, setMovieURL] = useState(API_URL);

  function getMovies(url){
    fetch(url).then(res => res.json()).then(data => {
        setMovies(data.results);
        setCurrentPage(data.page);
    })
    return movies;
  }

  return (
    <>
    <BrowserRouter>
      <MovieContext.Provider value={{ API_KEY, movies, setMovies, currentPage, setCurrentPage, API_URL, setAPI_URL, movieURL, setMovieURL, getMovies }}>
        <Routes>
          <Route path='/projects/mymdb' element={<><Header/><Content /><Footer/></>} />
          <Route path='/projects/now-playing' element={<><Header/><Content /><Footer/></>} />
        </Routes>
      </MovieContext.Provider>
    </BrowserRouter>
    </>
  );
}

export default App;
